import React from "react";
import { Link } from "react-router-dom";

import { Card, buttonClass } from "../lib/ui";

export default function NotFound() {
  return (
    <Card title="Page not found">
      <p className="text-slate-600">That page does not exist.</p>
      <Link to="/" className={`${buttonClass} mt-4`}>
        Go to the start
      </Link>
    </Card>
  );
}
